<template>
  <div class="doc-section">
    <div class="section-header">
      <span class="material-icons-sharp section-icon">price_check</span>
      <h2>Estimation</h2>
    </div>

    <p class="section-intro">
      Le module Estimation permet de simuler des prix de revient et de calculer des projections
      sur la base des données d'approvisionnement et des frais logistiques.
    </p>

    <!-- ===== PARAMÈTRES ===== -->
    <h3 class="sub-title">Paramètres de simulation</h3>
    <div class="table-wrapper">
      <table>
        <thead>
          <tr><th>Champ</th><th>Type</th><th>Obligatoire</th><th>Ce qu'il faut saisir</th></tr>
        </thead>
        <tbody>
          <tr><td><strong>Produit</strong></td><td>Liste déroulante</td><td><span class="required-badge badge-yes">Oui</span></td><td>Sélectionnez le produit à estimer.</td></tr>
          <tr><td><strong>Fournisseur</strong></td><td>Liste déroulante</td><td><span class="required-badge badge-cond">Conditionnel</span></td><td>Filtrer par fournisseur (optionnel selon le type d'estimation).</td></tr>
          <tr><td><strong>Transitaire</strong></td><td>Liste déroulante</td><td><span class="required-badge badge-no">Non</span></td><td>Filtrer par transitaire.</td></tr>
          <tr><td><strong>Période (début - fin)</strong></td><td>Dates</td><td><span class="required-badge badge-yes">Oui</span></td><td>Période sur laquelle baser le calcul.</td></tr>
        </tbody>
      </table>
    </div>

    <h4 class="sub-title">Procédure</h4>
    <div class="steps">
      <div class="step-item">
        <div class="step-num">1</div>
        <p>Ouvrez le module <strong>Estimation</strong> depuis le menu latéral.</p>
      </div>
      <div class="step-item">
        <div class="step-num">2</div>
        <p>Sélectionnez le <em>Produit</em> à estimer.</p>
      </div>
      <div class="step-item">
        <div class="step-num">3</div>
        <p>Affinez les filtres si nécessaire : <em>Fournisseur</em>, <em>Transitaire</em>.</p>
      </div>
      <div class="step-item">
        <div class="step-num">4</div>
        <p>Sélectionnez la <em>Période</em> de début et de fin.</p>
      </div>
      <div class="step-item">
        <div class="step-num">5</div>
        <p>Cliquez sur <span class="btn-ref">Charger les données</span>. Le système calcule et affiche les résultats.</p>
      </div>
    </div>

    <!-- ===== RÉSULTATS ===== -->
    <h3 class="sub-title">Lecture des résultats</h3>
    <p class="section-text">
      Les résultats présentent un tableau récapitulatif avec :
    </p>
    <ul class="doc-list">
      <li><strong>Coût d'achat</strong> : prix facturé par le fournisseur.</li>
      <li><strong>Frais de transit</strong> : coûts logistiques (transitaire + douane).</li>
      <li><strong>Frais divers</strong> : autres dépenses associées.</li>
      <li><strong>Prix de revient estimé</strong> : total des coûts par unité.</li>
      <li><strong>Projection de marge</strong> : différence entre le prix de vente et le prix de revient.</li>
    </ul>

    <div class="info-card info">
      <div class="card-title">
        <span class="material-icons-sharp" style="font-size:16px;color:#5b9bd5">info</span>
        Information
      </div>
      <p>
        Les estimations sont basées sur les données réelles enregistrées dans l'approvisionnement.
        Plus les données sont complètes (factures, dépenses, BL), plus l'estimation sera précise.
      </p>
    </div>
  </div>
</template>
<script>
export default { name: "DocEstimation" };
</script>
